import { useEffect, useState } from 'react';

// graphql
import { PageInfo, useCashiersChipsTransfersQuery, useCashiersChipsWithdrawalsQuery } from '@/generated/graphql';

// material ui
import { Grid } from '@mui/material';

// interfaces
import {
  ICashiersChipsTransferQueryVariable,
  mapGQLCashiersChipsTransfer,
  ICashiersChipsTransferTable,
  ICashiersChipsWithdrawalTable,
  ICashiersChipsWithdrawalQueryVariable,
  mapGQLCashiersChipsWithdrawal,
} from '@/shared/interfaces';

interface IProps {
  refetchCashiersChipsQuery: boolean;
  setRefetchCashiersChipsQuery: React.Dispatch<React.SetStateAction<boolean>>;
}

// components
import { TableCashiersChipsTransfers } from './cashiers-chips-transfer-table';
import { TableCashiersChipsWithdrawals } from './cashiers-chips-withdrawal-table';

export const CashiersChips = ({ refetchCashiersChipsQuery, setRefetchCashiersChipsQuery }: IProps) => {
  const [terminalBalTransfers, setTerminalBalTransfers] = useState<ICashiersChipsTransferTable[]>([]);
  const [terminalBalWithdrawals, setTerminalBalWithdrawals] = useState<ICashiersChipsWithdrawalTable[]>([]);

  const [terminalBalTransfersPageInfo, setTerminalBalTransfersPageInfo] = useState<PageInfo>();
  const [terminalBalTransfersTotalCount, setTerminalBalTransfersTotalCount] = useState<number>(0);
  const [terminalBalWithdrawalsPageInfo, setTerminalBalWithdrawalsPageInfo] = useState<PageInfo>();
  const [terminalBalWithdrawalsTotalCount, setTerminalBalWithdrawalsTotalCount] = useState<number>(0);

  const [cashiersChipsTransfersQueryVariable, setCashiersChipsTransfersQueryVariable] = useState<ICashiersChipsTransferQueryVariable>({
    first: 25,
  });
  const [cashiersChipsWithdrawalsQueryVariable, setCashiersChipsWithdrawalsQueryVariable] = useState<ICashiersChipsWithdrawalQueryVariable>(
    {
      first: 25,
    },
  );

  const cashiersChipsTransfersQuery = useCashiersChipsTransfersQuery({
    variables: cashiersChipsTransfersQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.cashiersChipsTransfers.nodes.map((x) => mapGQLCashiersChipsTransfer(x));

      const mappedTableData: ICashiersChipsTransferTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        createdAt: x.createdAt,
        username: x.admin.user.username,
      }));

      setTimeout(() => {
        setTerminalBalTransfers(mappedTableData);
        setTerminalBalTransfersPageInfo(data.cashiersChipsTransfers.pageInfo);
        setTerminalBalTransfersTotalCount(data.cashiersChipsTransfers.totalCount);
      }, 100);
    },
  });

  const cashiersChipsWithdrawalsQuery = useCashiersChipsWithdrawalsQuery({
    variables: cashiersChipsWithdrawalsQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.cashiersChipsWithdrawals.nodes.map((x) => mapGQLCashiersChipsWithdrawal(x));

      const mappedTableData: ICashiersChipsWithdrawalTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        createdAt: x.createdAt,
        username: x.admin.user.username,
      }));

      setTimeout(() => {
        setTerminalBalWithdrawals(mappedTableData);
        setTerminalBalWithdrawalsPageInfo(data.cashiersChipsWithdrawals.pageInfo);
        setTerminalBalWithdrawalsTotalCount(data.cashiersChipsWithdrawals.totalCount);
      }, 100);
    },
  });

  useEffect(() => {
    if (refetchCashiersChipsQuery === true) {
      console.log('REFETCH');
      setRefetchCashiersChipsQuery(false);
      cashiersChipsTransfersQuery.refetch({
        ...cashiersChipsTransfersQueryVariable,
      });
      cashiersChipsWithdrawalsQuery.refetch({
        ...cashiersChipsWithdrawalsQueryVariable,
      });
    }
  }, [refetchCashiersChipsQuery]);

  return (
    <>
      <Grid container spacing={2} px={2}>
        <Grid size={6}>
          <TableCashiersChipsTransfers
            rows={terminalBalTransfers}
            setCashiersChipsTransferQueryVariable={setCashiersChipsTransfersQueryVariable}
            cashiersChipsTransferQueryVariable={cashiersChipsTransfersQueryVariable}
            totalCount={terminalBalTransfersTotalCount}
            pageInfo={terminalBalTransfersPageInfo}
            getCashiersChipsTransferLoading={cashiersChipsTransfersQuery.loading}
          />
        </Grid>
        <Grid size={6}>
          <TableCashiersChipsWithdrawals
            rows={terminalBalWithdrawals}
            setCashiersChipsWithdrawalQueryVariable={setCashiersChipsWithdrawalsQueryVariable}
            cashiersChipsWithdrawalQueryVariable={cashiersChipsWithdrawalsQueryVariable}
            totalCount={terminalBalWithdrawalsTotalCount}
            pageInfo={terminalBalWithdrawalsPageInfo}
            getCashiersChipsWithdrawalLoading={cashiersChipsWithdrawalsQuery.loading}
          />
        </Grid>
      </Grid>
    </>
  );
};
